<template>
  <el-dialog
    title="Deposit"
    :visible="dialog_deposit"
    width="30%"
    top="3vh"
    :modal="true"
    @close="
      setCampaignDeposit(false)
      deposit = null
    "
  >
    <el-input
      type="number"
      v-model="deposit"
      clearable
      placeholder="Insert number..."
    />
    <div slot="footer">
      <el-button type="primary" size="mini" @click="depositVidcents">
        Save
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      deposit: null
    }
  },

  computed: {
    ...mapState('labelVidCents', ['dialog_deposit'])
  },

  methods: {
    ...mapActions('labelVidCents', ['depositCampaign']),
    ...mapMutations('labelVidCents', ['setCampaignDeposit']),

    depositVidcents() {
      if (parseFloat(this.deposit) < 0) {
        this.$message({
          type: 'error',
          message: 'Amount needs to be greater then 0!'
        })
      } else {
        this.depositCampaign(this.deposit)
        this.deposit = null
      }
    }
  }
}
</script>
